import { loginSuccess } from "../../../store/slices/authSlice";

export default function responseGoogleLogin(response: any, api: any, arg: any) {
    console.log("Response in responseGoogleLogin handler:", response);
    if (response && response.data?.token && response.data?.user) {
        // Use the user data returned from our updated backend
        api.dispatch(loginSuccess({ token: response.data.token, user: response.data.user }));
    }
    return response?.data || null;
}
